import React, { useEffect, useState } from 'react';
import Link from 'next/link';
import { doc, getDoc } from 'firebase/firestore/lite';
import { firebaseFireStore } from '../../config/firebaseFirestore';

export default function AuthorCard(props) {
  const [isSellerMentor, setisSellerMentor] = useState(false);

  useEffect(() => {
    if (props.ele && props.ele.id) {
      isUserMinterFunc();
    }
  }, [props.ele.id]);

  const isUserMinterFunc = async () => {
    let dbRef = await getDoc(
      doc(firebaseFireStore, 'musicartMinters', props.ele.id),
    );
    if (dbRef.data()) {
      setisSellerMentor(true);
    }
  };

  return (
    <>
      <div className="author">
        <Link prefetch={false} href={'/collector/' + props.ele.id}>
          <a
            style={{ display: 'flex', width: '100%', flexDirection: 'column' }}
          >
            <div
              className="author__cover author__cover--bg"
              style={{
                backgroundColor: '#ff9700',
                backgroundImage: props.ele.thumbnailImage
                  ? 'url(' +
                    props.ele.thumbnailImage +
                    '_214x214?alt=media' +
                    ')'
                  : 'none',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
              }}
            ></div>
          </a>
        </Link>
        <div className="author__meta">
          <Link prefetch={false} href={'/collector/' + props.ele.id}>
            <a style={{ display: 'block' }}>
              <>
                <div
                  className={
                    isSellerMentor
                      ? 'author__avatar author__avatar--verified'
                      : 'author__avatar'
                  }
                  style={{ backgroundColor: '#ff9700' }}
                >
                  <img
                    src={
                      props.ele.photoUrl
                        ? props.ele.photoUrl + '_250x250?alt=media'
                        : '/img/avatars/avatar.jpg'
                    }
                    alt=""
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = '/img/avatars/avatar.jpg';
                    }}
                  />
                </div>
                {/* <h3 className="author__name text_in_one_line">
                  {props.ele.name
                    ? props.ele.name.length > 12
                      ? props.ele.name.substring(0, 12) + "..."
                      : props.ele.name
                    : "-"}
                </h3> */}
                <h3 className="author__nickname">
                  @
                  {props.ele.collectorUserName
                    ? props.ele.collectorUserName.length > 12
                      ? props.ele.collectorUserName.substring(0, 12) + '...'
                      : props.ele.collectorUserName
                    : 'unknown'}
                </h3>
                <p className="author__text author-bio">
                  {props.ele.bio ? props.ele.bio.substring(0, 20) + '...' : '-'}
                </p>
              </>
            </a>
          </Link>
        </div>
      </div>
    </>
  );
}
